'use client'

import { getLinkRel, isExternalUrl } from '@/lib/utils/link-utils'
import { Picture } from '@/ui/media/picture/Picture.client'
import { generatePictureSource } from '@/ui/media/picture/Picture.service'

import type { FooterAppDownloadProps } from './Footer.schema'

import { Link } from '@/ui/links/link/Link.client'

type FooterAppDownloadComponentProps = {
  appDownload: FooterAppDownloadProps
}

export function FooterAppDownload({ appDownload }: FooterAppDownloadComponentProps) {
  return (
    <div className="flex flex-col gap-2">
      <p className="font-bold">{appDownload.title}</p>
      <div className="flex gap-2">
        {appDownload.links.map(({ alt, storeIcon, url }) => (
          <Link
            variant="free"
            underlined="hover"
            key={`${url}-${alt}`}
            className="data-[focus-visible]:outline-brand-1-700' flex w-fit flex-col gap-1 overflow-hidden rounded-sm border-px border-solid border-white data-[pressed]:translate-y-px data-[hovered]:border-brand-2-800 hd:border-1.5"
            href={url}
            opensInNewTab={isExternalUrl(url)}
            rel={getLinkRel(url)}
          >
            <Picture
              image={generatePictureSource({ desktopUrl: storeIcon, alt })}
              height="40"
              mode="contain"
            />
          </Link>
        ))}
      </div>
    </div>
  )
}
